import React from 'react';
import { ThemeProvider } from '@xstyled/styled-components';
import theme from '@tsnpm/uikit/dist/theme';
import { CookieContextProvider } from '@ts/commons/ContextCookie';
import AuthProvider from '@ts/commons/AuthProvider';
import Root from './containers/App';
import GlobalStyle from './styled';

import 'react-day-picker/lib/style.css';
import 'react-phone-number-input/style.css';
import 'tippy.js/dist/tippy.css';
import 'tingle.js/dist/tingle.css';

import './App.module.css';
import './assets/css/base.css';
import './assets/css/dropdown.css';
import './assets/css/fa.css';
import './assets/css/h.css';
import './assets/css/react-phone-number.css';
import './assets/css/scrollbars.css';
import './assets/css/stripe.css';
import './assets/css/table.css';
import './assets/css/tingle.css';
import './assets/css/tippy.css';

const App = () => (
    <ThemeProvider theme={theme}>
        <AuthProvider>
            <CookieContextProvider>
                <GlobalStyle key="styled" />
                <Root key="root" />
            </CookieContextProvider>
        </AuthProvider>
    </ThemeProvider>
);

export default App;
